module.exports = __webpack_public_path__ + "static/media/requestsGrey.e0f8d8e2.svg";